import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { ActivityState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'ShowEnumActivityState',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case ActivityState.ADS_NOT_STARTED:
      return t('Base.wait')
    case ActivityState.ADS_IN_ACTION:
      return t('Base.inAction')
    case ActivityState.ADS_CLOSE:
      return t('Base.finish')
  }
  return t('Base.unknown')
})

const color = computed(() => {
  if (props.state == ActivityState.ADS_IN_ACTION) {
    return '#5e4eff'
  }
  return '#5A5F6F'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})